var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicencas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4819 -2913)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4819 2913)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5531.621 -2747.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M730.842-141.092a1.174,1.174,0,0,1-.846-.371l-3.309-3.6a.492.492,0,0,1,.025-.695l.005-.005a.51.51,0,0,1,.356-.132.5.5,0,0,1,.344.157l3.309,3.6a.169.169,0,0,0,.114.052.174.174,0,0,0,.119-.047l8.371-8.351a.5.5,0,0,1,.7.006.5.5,0,0,1-.007.7l-8.371,8.344A1.144,1.144,0,0,1,730.842-141.092Z",
    transform: "translate(-0.854 -0.775)",
    fill: "#1d252c",
    stroke: "#1d252c",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(721.621 -157.672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.632,2.864a.453.453,0,0,0-.332-.345L39.422.014a.455.455,0,0,0-.224,0l-9.877,2.5a.453.453,0,0,0-.332.346c-.033.154-3.128,15.455,10.143,21.1a.457.457,0,0,0,.356,0C52.76,18.318,49.665,3.017,49.632,2.864ZM39.311,23.051c-11.577-5.06-9.858-17.641-9.486-19.724l9.486-2.4,9.486,2.4C49.169,5.411,50.888,17.991,39.311,23.051Z",
    transform: "translate(-28.654 0)",
    fill: "#1d252c",
    stroke: "#1d252c",
    strokeWidth: 0.1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicencas);
export default __webpack_public_path__ + "static/media/licencas.4bec14103fd936c4a09cc94ac675fb1e.svg";
export { ForwardRef as ReactComponent };